var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-expand-transition",
    [
      _vm.sysBarInfo.status
        ? _c(
            "v-system-bar",
            {
              class: [
                _vm.sysBarInfo.inset
                  ? "no-print custom-system-bar"
                  : "no-print no-inset"
              ],
              attrs: {
                app: "",
                dark: "",
                window: "",
                height: "35",
                "lights-out": "",
                color: _vm.sysBarInfo.color
              }
            },
            [
              _c("v-icon", { staticClass: "mr-4" }, [_vm._v("check")]),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "text-body-2 font-weight-bold white--text" },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.sysBarInfo.message) +
                      "\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-icon",
                {
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.close.apply(null, arguments)
                    }
                  }
                },
                [_vm._v("\n            mdi-close\n        ")]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-295f2106", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-295f2106","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/commons/SystemBar.vue
// module id = null
// module chunks = 